import { ProtocolAddress } from '../../../types/protocol'
import {
  genrateLevelAddress,
  genrateKeyLevelAddress,
  genratSensorModeAddress,
  genrateMacroAddressLevel,
} from './addressGenerators'

export const ADDRESS_VT_CH584 = {
  CURRENT_CONNECT_PROTOCOL: [0x04, 0x01], //当前使用的通信协议，0：2.4G 连接方式；1: BLE 连接方式;
  CONFIG_CURRENT: [0x0c, 0x01],
  RF_PROTOCOL_SETTING: [0x60, 0x00],
  // 哪种定义Level的Address都可以
  // CONFIG_NAME: [ //方式一 直接定义
  //   [0x0C, 0x09],
  //   [0x0C, 0x0d],
  //   [0x0C, 0x11],
  //   [0x0C, 0x15],
  //   [0x0C, 0x19],
  //   [0x0C, 0x1d],
  //   [0x0C, 0x21],
  //   [0x0C, 0x25],
  // ],
  FW_VERSION_0: [0x10, 0x00], //固件版本字节 1（ 最低字节）
  FW_VERSION_1: [0x11, 0x00], //固件版本字节 2
  FW_VERSION_2: [0x12, 0x00], //固件版本字节 3
  FW_VERSION_3: [0x13, 0x00], //固件版本字节 4（ 最高字节）
  PAIRING_1: [0x20, 0x00], //对码地址 1 的最低字节
  PAIRING_3: [0x28, 0x00], //对码地址 2 （备份）的最低字节
  PAIRING_4: [0x30, 0x00], //对码地址 3 （备份）的最低字节
  CONFIG_NAME: genrateLevelAddress(0x00ec), //方式二 方法生成
  // 定义鼠标EEPROM位置
  MOUSE_LEFT: genrateLevelAddress(0x0000), //左键
  MOUSE_MID: genrateLevelAddress(0x0004), //中键
  MOUSE_RIGHT: genrateLevelAddress(0x0008), //右键
  MOUSE_CPIADD: genrateLevelAddress(0x000c), //DP+
  MOUSE_CPIREDUCE: genrateLevelAddress(0x0010), //DPI-
  MOUSE_FORWARD: genrateLevelAddress(0x0014), //前进键
  MOUSE_BACK: genrateLevelAddress(0x0018), //后退键
  MOUSE_ROLLFORWARD: genrateLevelAddress(0x0024), //滚轮前滚
  MOUSE_ROLLBACK: genrateLevelAddress(0x0028), //滚轮后滚
  MOUSE_ROLLRIGHT: genrateLevelAddress(0x002c), //滚轮右滚
  MOUSE_ROLLLEFT: genrateLevelAddress(0x0030), //滚轮左滚
  MOUSE_BOTTOM: genrateLevelAddress(0x0034), //底部自定义键
  MOUSE_BLE: genrateLevelAddress(0x0038), //蓝牙键
  MOUSE_KEY_LIST: genrateKeyLevelAddress(), //按键列表

  MOUSE_REPORT: genrateLevelAddress(0x0040), //回报率
  MOUSE_SCAN_RATE: genrateLevelAddress(0x0041), //扫描率
  MOUSE_SLIGHT: genrateLevelAddress(0x0044), //静默高度
  MOUSE_MOTION: genrateLevelAddress(0x0045), //移动同步
  MOUSE_DPI_X_LIST: genrateLevelAddress(0x0048), //X轴DPI数值
  MOUSE_DPI_CUR: genrateLevelAddress(0x0058), //当前DPI档位
  MOUSE_DPI_Y_LIST: genrateLevelAddress(0x0088), //Y轴DPI数值
  MOUSE_DPI_ENABLE_GEAR: genrateLevelAddress(0x0056), //DPI的可用档位
  MOUSE_DPI_GEAR_LENGTH: 7, //DPI的最大档位7 常量 非地址但相关
  MOUSE_DOWNDELAY: genrateLevelAddress(0x0080), //按下消抖延时
  MOUSE_LIFTDELAY: genrateLevelAddress(0x0081), //抬起消抖延时
  MOUSE_SLEEPTIME: genrateLevelAddress(0x0082), //睡眠时间
  MOUSE_LINEAR_RIPPLE: genrateLevelAddress(0x0083), //直线修正曲线修正
  MOUSE_SENSORANGLE: genrateLevelAddress(0x0084), //传感器角度
  MOUSE_GLASS: genrateLevelAddress(0x0085), //玻璃过面
  MOUSE_LOWPOWER: genrateLevelAddress(0x0086), //TODO不存在，sensor低功耗模式
  MOUSE_LIGHTMOD: genrateLevelAddress(0x0059), //TODO不存在,99:灯光模式 9A：灯光速度 9B:灯光亮度
  MOUSE_LIGHTRGB: genrateLevelAddress(0x0078), //TODO不存在,鼠标灯光颜色
  MOUSE_POWERSAVE: genrateLevelAddress(0x006c), //TODO不存在,鼠标节能模式
  RF_STRENGTHEN_SWITCH: genrateLevelAddress(0x0098), //rf强化开关
  LOW_POWE_WARN_SWITCH: genrateLevelAddress(0x0099), //低电量提示开关
  LOW_DC_SWITCH: genrateLevelAddress(0x009a), //DC 开/关
  MOUSE_REPORT_SENSOR_MODE: genratSensorModeAddress(0x009c), //传感器模式
  MACRO_PACKAGE_ADDRESS: genrateMacroAddressLevel(0x00010000, 12), // 宏包地址
  MACRO_NAME_ADDRESS: genrateMacroAddressLevel(0x0000fd00, 12, 0x10), // 宏包名称地址
  MACRO_PRESSURE_ADDRESS: genrateMacroAddressLevel(0x00020000, 4), // 压枪宏包地址
} as const satisfies ProtocolAddress
